export enum ProjectStatus {
  ready = 0,
  intiailising = 1,
  error = 2,
}
